import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
// Intentionally NOT importing generated `attachSupabaseAuth` from
// `@/integrations/supabase/auth-attacher` - the generated version does not
// refresh expired persisted sessions before attaching the bearer token,
// which produced first-load "Try again" errors on Smart QA and other
// authenticated panels. See auth-attacher-refresh.ts for the fix.
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher-refresh";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware],
}));
